var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mainView" },
    [
      _c("el-scrollbar", { staticStyle: { height: "calc(100vh - 148px)" } }, [
        _c(
          "div",
          { staticClass: "eachRow flexRowCenter" },
          [
            _vm._l(_vm.dateTypeList, function (item) {
              return _c(
                "div",
                {
                  staticClass: "dateType",
                  class: _vm.dateSelect == item ? "dateTypeSelect" : "",
                  on: {
                    click: function ($event) {
                      return _vm.handleClickDateType(item)
                    },
                  },
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            _c("el-date-picker", {
              ref: "datePicker",
              attrs: {
                type: "daterange",
                "unlink-panels": "",
                size: "small",
                "range-separator": "-",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "picker-options": _vm.pickerOptions,
                clearable: false,
              },
              on: { change: _vm.didSelectDate },
              model: {
                value: _vm.timeRange,
                callback: function ($$v) {
                  _vm.timeRange = $$v
                },
                expression: "timeRange",
              },
            }),
            _c("div", { staticStyle: { width: "16px" } }),
            _c(
              "el-select",
              {
                staticStyle: { width: "130px" },
                attrs: { size: "small" },
                model: {
                  value: _vm.goodsType,
                  callback: function ($$v) {
                    _vm.goodsType = $$v
                  },
                  expression: "goodsType",
                },
              },
              [
                _c("el-option", {
                  attrs: { label: "消肿止痛贴", value: "消肿止痛贴" },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "16px" },
                attrs: { size: "small", type: "default", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.reset()
                  },
                },
              },
              [_vm._v("重置")]
            ),
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.query()
                  },
                },
              },
              [_vm._v("查询")]
            ),
          ],
          2
        ),
        _c("div", { staticClass: "divider" }),
        _c("div", { staticClass: "eachRow" }, [
          _c("div", { staticClass: "flexRowCenter" }, [
            _c("span", { staticClass: "titleName" }, [
              _vm._v(_vm._s(_vm.userInfo.shopName || "省区")),
            ]),
            _c("span", { staticClass: "timeText" }, [
              _vm._v("统计时间：" + _vm._s(_vm.getTimeShow())),
            ]),
            _c("span", { staticClass: "timeText" }, [
              _vm._v("更新时间：" + _vm._s(_vm.freshTime)),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "columnflexRowCenter",
              staticStyle: { height: "100px" },
            },
            _vm._l(_vm.orderCountList, function (item) {
              return _c("div", { staticClass: "columnView" }, [
                _c("span", { staticClass: "columnViewTitle" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _c("div", { staticClass: "flexRowEnd" }, [
                  _c("span", { staticClass: "money" }, [
                    _vm._v(_vm._s(_vm.fixStr(item.count, item.key))),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "divider" }),
        _c(
          "div",
          { staticClass: "eachRow" },
          [
            _c(
              "el-table",
              {
                ref: "elTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  d: "",
                  "highlight-current-row": "",
                },
                on: { "current-change": _vm.handleCurrentChange },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "排名", type: "index", width: "60" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "district", label: "采购方名称" },
                }),
                _c("el-table-column", {
                  attrs: { label: "采购件数（件）" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.provincialBusinessOrderNumber || 0
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "应付总额（元）" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.fixtoTwo(
                                    scope.row.provincialBusinessNeedPayTotal
                                  )
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "provincialBusinessOrderVolumeTotal",
                    label: "采购订单",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "provincialBusinessOrderFulfillmentQuantity",
                    label: "完成订单",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "完成收货（件）" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row
                                  .provincialBusinessNumberOfCompletedProducts ||
                                  0
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "应到总额（元）" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.fixtoTwo(
                                    scope.row
                                      .provincialBusinessAmountReceivableTotal
                                  )
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "实到总额（元）" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.fixtoTwo(
                                    scope.row
                                      .provincialBusinessAmountReceivedTotal
                                  )
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }